import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";

export default function NCR({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [ncrData, setDprData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    StartDate: "",
    EndDate: "",
    NatureOfActivity: "",
    ObservationStatus: "",
    ObservationCategory: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(ncrData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = ncrData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalNCR = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.GetNCRs(obj);
    if (response && response.QualityNCRList.length > 0) {
      setDprData(response.QualityNCRList);
    } else {
      setDprData([]);
    }
  };
  useEffect(() => {
    fetchArchivalNCR();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Quality NCR Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpen(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="StartDate"
                    value={filterData.StartDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Nature of activity</label>
                  <input
                    type="text"
                    name="NatureOfActivity"
                    value={filterData.NatureOfActivity}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Observation Status</label>
                  <select
                    name="ObservationClosed"
                    value={filterData.ObservationClosed}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select observation status</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Observation Category</label>
                  <select
                    name="ObservationCategory"
                    value={filterData.ObservationCategory}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select observation category</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Manpower</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: 20 }}>
          {["Site Vist/Audit Date", "Created Date", "Nature of Activity"].map(
            (sortOption) => (
              <div className="form-check" key={sortOption}>
                <input
                  className="form-check-input shadow-none"
                  type="radio"
                  name="sortBy"
                  id={sortOption}
                  value={sortOption}
                  checked={filterData.sortBy === sortOption}
                  onChange={handleChange}
                />
                <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                  {sortOption}
                </label>
              </div>
            )
          )}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalNCR(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport data={ncrData} fileName="NCR" sheet="NCR List" />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalNCR()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>Project Number</th>
              <th>Project Name</th>
              <th>Location</th>
              <th>Region</th>

              <th>Product</th>
              <th>Solution</th>
              <th>Execution Partner</th>
              <th>Component Manufacturer</th>
              <th title="Site Visit Date/Audit Date">Site Visit...</th>
              <th>Nature of Activity</th>
              <th>Description of work </th>
              <th title="Observation Related To">Observation Rel...</th>
              <th title="Protocol Mantained for the said activity">
                Protocol Ma...
              </th>
              <th>Observation By</th>
              <th title="Brief Description of the obseravation">
                Brief Des...
              </th>
              <th>Observation Category</th>
              <th title="Proposed Corrective Action">Proposed C...</th>
              <th>Observation Closed</th>
              <th title="Observation closed by(Name of the Department)">
                Observation C...
              </th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index} onClick={onOpenModal}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>

                <td> {row.ProjectNumber}</td>
                <td>{row.ProjectName}</td>
                <td>{row.ProjectLocation}</td>
                <td>{row.Region}</td>
                <td>{row.Product}</td>
                <td>{row.Solution}</td>
                <td>{row.ExecutionPartner}</td>
                <td>{row.ComponentManufacturer}</td>
                <td>{row.SiteVisitDate_AuditDate}</td>
                <td>{row.NatureofActivity}</td>
                <td>{row.DescriptionofWork}</td>
                <td>{row.Observationrelatedto}</td>
                <td>{row.Protocolsmaintainedforthesaidactivity}</td>
                <td>{row.ObservationBy}</td>
                <td>{row.BriefDescriptionoftheobservation}</td>
                <td>{row.ObservationCategory}</td>
                <td>{row.Proposedcorrectiveaction}</td>
                <td>{row.ObservationClosed}</td>
                <td>{row.Observationtobeclosedby_Nameofdepartment}</td>
                <td>{new Date(row?.CreateOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, ncrData.length)} to{" "}
          {Math.min(currentPage * rowsPerPage, ncrData.length)} of{" "}
          {ncrData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
